// extracted by mini-css-extract-plugin
export default {"label":"calendarLabel_label__3EpJB"};